import { AttachFile } from "@mui/icons-material";
import { downloadFile } from "apis/controllers/files";
import fileDownload from "js-file-download";
import { useSnackbar } from "notistack";
import { isExcelHistoryFile } from "../utils/historyFileTypes";

const HistoryFileLink = ({ file, index, onPreview }) => {
  const { enqueueSnackbar } = useSnackbar();
  const isExcel = isExcelHistoryFile(file);
  const fileName = file?.origFName || file?.name;
  const fallbackExtension =
    (file?.type ?? file?.contentType)?.toLowerCase() === "application/vnd.ms-excel"
      ? "xls"
      : "xlsx";
  const downloadName =
    fileName || `file-${file?.id ?? index + 1}.${fallbackExtension}`;

  const handleClick = async () => {
    if (!isExcel) {
      onPreview(file);
      return;
    }

    try {
      const data = await downloadFile({ Id: file.id }, { responseType: "blob" });
      fileDownload(data, downloadName);
    } catch {
      enqueueSnackbar("Δεν ήταν δυνατή η λήψη του αρχείου.", {
        variant: "error",
      });
    }
  };

  return (
    <button
      type="button"
      onClick={handleClick}
      title={fileName}
      aria-label={`${isExcel ? "Λήψη" : "Προεπισκόπηση"} ${fileName || `αρχείου ${index + 1}`}`}
      style={{
        color: "#387de7",
        textDecoration: "underline",
        cursor: "pointer",
        marginTop: 3,
        border: 0,
        padding: 0,
        background: "transparent",
        font: "inherit",
        display: "inline-flex",
        alignItems: "center",
      }}
    >
      {index + 1}
      <AttachFile sx={{ fontSize: 20 }} />
    </button>
  );
};

export default HistoryFileLink;
